import BT from "../assets/thumbnails/BT.webp";
import FDC from "../assets/thumbnails/FDC.webp";
import FDL from "../assets/thumbnails/FDL.webp";
import FS from "../assets/thumbnails/FS.webp";
import COC from "../assets/thumbnails/COC.webp";
import FDE from "../assets/thumbnails/FDE.webp";
import FDFL from "../assets/thumbnails/FDFL.webp";
import GC from "../assets/thumbnails/GC.webp";
import MRM from "../assets/thumbnails/MRM.webp";
import FDC5 from "../assets/thumbnails/FDC5.webp";
import FDC10 from "../assets/thumbnails/FDC10.webp";
import FDC40 from "../assets/thumbnails/FDC40.webp";
import FDC100 from "../assets/thumbnails/FDC100.webp";
import FDL5 from "../assets/thumbnails/FDL5.webp";
import FDL10 from "../assets/thumbnails/FDL10.webp";
import FDL100 from "../assets/thumbnails/FDL100.webp";
import BS20 from "../assets/thumbnails/BS20.webp";
import BS20C from "../assets/thumbnails/BS20C.webp";
import BS40 from "../assets/thumbnails/BS40.webp";
import WB20 from "../assets/thumbnails/WB20.webp";
import FM from "../assets/thumbnails/FM.webp";
import CF from "../assets/thumbnails/CF.webp";
import CF40 from "../assets/thumbnails/CF40.webp";
import CM from "../assets/thumbnails/CM.webp";
import FP from "../assets/thumbnails/FP.webp";
import WR from "../assets/thumbnails/WR.webp";
import UTR from "../assets/thumbnails/UTR.webp";
import BS5 from "../assets/thumbnails/BS5.webp";
import BS10 from "../assets/thumbnails/BS10.webp";
import ZOF from "../assets/thumbnails/ZOF.webp";
import WD from "../assets/thumbnails/WD.webp";
import PB from "../assets/thumbnails/PB.webp";
import FR from "../assets/thumbnails/FR.webp";
import DLC20 from "../assets/thumbnails/DLC20.webp";
import CPU10 from "../assets/thumbnails/CPU10.webp";
import ET from "../assets/thumbnails/ET.webp";
import BOO from "../assets/thumbnails/BOO.webp";

export interface GameTiles {
  abbreviation: string;
  gameId: number;
  name: string;
  image: string;
  isPlayable: boolean;
}

export const FDC_GAMES: GameTiles[] = [
  {
    abbreviation: "5FDC",
    gameId: 10,
    name: "Fruit Dojo Classic 5",
    image: FDC5,
    isPlayable: true,
  },
  {
    abbreviation: "10FDC",
    gameId: 11,
    name: "Fruit Dojo Classic 10",
    image: FDC10,
    isPlayable: true,
  },
  {
    abbreviation: "FDC",
    gameId: 3,
    name: "Fruit Dojo Classic",
    image: FDC,
    isPlayable: true,
  },
  {
    abbreviation: "40FDC",
    gameId: 12,
    name: "Fruit Dojo Classic 40",
    image: FDC40,
    isPlayable: true,
  },
  {
    abbreviation: "100FDC",
    gameId: 13,
    name: "Fruit Dojo Classic 100",
    image: FDC100,
    isPlayable: true,
  },
];

export const FDL_GAMES: GameTiles[] = [
  {
    abbreviation: "5FDL",
    gameId: 14,
    name: "Fruit Dojo Legacy 5",
    image: FDL5,
    isPlayable: true,
  },
  {
    abbreviation: "10FDL",
    gameId: 15,
    name: "Fruit Dojo Legacy 10",
    image: FDL10,
    isPlayable: true,
  },
  {
    abbreviation: "FDL",
    gameId: 1,
    name: "Fruit Dojo Legacy",
    image: FDL,
    isPlayable: true,
  },
  {
    abbreviation: "FDFL",
    gameId: 2,
    name: "Fruit Dojo Legacy 40",
    image: FDFL,
    isPlayable: true,
  },
  {
    abbreviation: "100FDL",
    gameId: 16,
    name: "Fruit Dojo Legacy 100",
    image: FDL100,
    isPlayable: true,
  },
];

export const CASCADE_GAMES: GameTiles[] = [
  {
    abbreviation: "BT",
    gameId: 5,
    name: "Basilica Treasures",
    image: BT,
    isPlayable: true,
  },
  {
    abbreviation: "GC",
    gameId: 7,
    name: "Gummy Crush",
    image: GC,
    isPlayable: true,
  },
  {
    abbreviation: "WR",
    gameId: 23,
    name: "Wild Revolver",
    image: WR,
    isPlayable: true,
  },
];

export const BURNING_7S_AND_MORE: GameTiles[] = [
  {
    abbreviation: "20BS",
    gameId: 17,
    name: "Burning Sevens 20",
    image: BS20C,
    isPlayable: true,
  },
  {
    abbreviation: "40BS",
    gameId: 22,
    name: "Burning Sevens 40",
    image: BS40,
    isPlayable: true,
  },
  {
    abbreviation: "FM",
    gameId: 21,
    name: "Fruity Multiplier",
    image: FM,
    isPlayable: true,
  },
  {
    abbreviation: "5BS",
    gameId: 28,
    name: "Burning Sevens 5",
    image: BS5,
    isPlayable: true,
  },
  {
    abbreviation: "10BS",
    gameId: 29,
    name: "Burning Sevens 10",
    image: BS10,
    isPlayable: true,
  },
];

export const BURNING_7S_SCATTERS_RESPIN: GameTiles[] = [
  {
    abbreviation: "20BSS",
    gameId: 36,
    name: "Burning Sevens 20 Scatters Respin",
    image: BS20,
    isPlayable: true,
  },
  {
    abbreviation: "40BSS",
    gameId: 35,
    name: "Burning Sevens 40 Scatters Respin",
    image: BS40,
    isPlayable: true,
  },
  {
    abbreviation: "5BSS",
    gameId: 33,
    name: "Burning Sevens 5 Scatters Respin",
    image: BS5,
    isPlayable: true,
  },
  {
    abbreviation: "10BSS",
    gameId: 34,
    name: "Burning Sevens 10 Scatters Respin",
    image: BS10,
    isPlayable: true,
  },
];

export const PB_GAMES: GameTiles[] = [
  {
    abbreviation: "20WB",
    gameId: 18,
    name: "Wild Booty",
    image: WB20,
    isPlayable: true,
  },
  {
    abbreviation: "FM",
    gameId: 21,
    name: "Fruity Multiplier",
    image: FM,
    isPlayable: true,
  },
  {
    abbreviation: "FR",
    gameId: 37,
    name: "Fruity Respins",
    image: FR,
    isPlayable: true,
  },
  {
    abbreviation: "FP",
    gameId: 26,
    name: "Fortune Porky",
    image: FP,
    isPlayable: true,
  },
  {
    abbreviation: "UTR",
    gameId: 24,
    name: "Under The Radar",
    image: UTR,
    isPlayable: true,
  },
  {
    abbreviation: "20DLC",
    gameId: 38,
    name: "Double Lucky Clovers",
    image: DLC20,
    isPlayable: true,
  },
  {
    abbreviation: "CPU",
    gameId: 41,
    name: "Crown Power Up",
    image: CPU10,
    isPlayable: true,
  },
];

export const BONUS_GAMES: GameTiles[] = [
  {
    abbreviation: "FS",
    gameId: 6,
    name: "Fruit Sensei",
    image: FS,
    isPlayable: true,
  },
  {
    abbreviation: "CF",
    gameId: 19,
    name: "Crown Fortune",
    image: CF,
    isPlayable: true,
  },
  {
    abbreviation: "40CF",
    gameId: 20,
    name: "Crown Fortune 40",
    image: CF40,
    isPlayable: true,
  },
  {
    abbreviation: "CM",
    gameId: 25,
    name: "Crocy Montana",
    image: CM,
    isPlayable: true,
  },
  {
    abbreviation: "15ZF",
    gameId: 30,
    name: "Zombies of Fortune",
    image: ZOF,
    isPlayable: true,
  },
  {
    abbreviation: "15WD",
    gameId: 32,
    name: "Wild Derby",
    image: WD,
    isPlayable: true,
  },
  {
    abbreviation: "10BOO",
    gameId: 40,
    name: "Book of Olympus",
    image: BOO,
    isPlayable: true,
  },
];

export const WAYS_GAMES: GameTiles[] = [
  {
    abbreviation: "PB",
    gameId: 31,
    name: "Piñata Bonk",
    image: PB,
    isPlayable: true,
  },
  {
    abbreviation: "27ET",
    gameId: 39,
    name: "Gems of Isis",
    image: ET,
    isPlayable: true,
  },
];

export const OTHER_GAMES: GameTiles[] = [
  {
    abbreviation: "COC",
    gameId: 8,
    name: "Cash of Clans",
    image: COC,
    isPlayable: false,
  },
  {
    abbreviation: "MRM",
    gameId: 9,
    name: "Mr. Miner",
    image: MRM,
    isPlayable: false,
  },
  {
    abbreviation: "FDE",
    gameId: 4,
    name: "Fruit Dojo Explosion",
    image: FDE,
    isPlayable: false,
  },
];
export const GAMES: GameTiles[] = [
  ...FDC_GAMES,
  ...FDL_GAMES,
  ...CASCADE_GAMES,
  ...BURNING_7S_AND_MORE,
  ...BURNING_7S_SCATTERS_RESPIN,
  ...PB_GAMES,
  ...BONUS_GAMES,
  ...WAYS_GAMES,
  ...OTHER_GAMES,
];
